import axios from 'axios';
import {
  SET_AUTH_TOKENS,
} from './../../constants/ActionTypes';
import configureStore from '../../store';
import { clearLocalStorage, setAuthToken } from '../../utils';
import jwtAxios from './ApiConfig'

const store = configureStore()

jwtAxios.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;
    if (err.response &&
        err.response.status === 401 && 
        err.response.data.code === 'token_not_valid'
      ) {
      console.log('Need to logout user');
      originalRequest._retry = true;
      const refresh = localStorage.getItem('refresh')
      if(refresh) {
        clearLocalStorage()
        try {
          let res = await jwtAxios.post('auth/token/refresh', { refresh }); 
          if(res && res.data) {
            originalRequest.headers['Authorization'] = 'Bearer ' + res.data.access;
            setAuthToken(res.data.access, res.data.refresh);
            store.dispatch({ type: SET_AUTH_TOKENS, payload: res.data });
          }
        } catch (err: any) {
          return Promise.reject(err);
        }
        return axios(originalRequest)
      }
    }
    return Promise.reject(err);
  },
);

export default jwtAxios;
